import {
  GET_CONSTRUCTION_TYPES,
  GET_CONSTRUCTION_TYPES_SUCCESS,
  GET_CONSTRUCTION_TYPES_ERROR,
  ADD_CONSTRUCTION_TYPE,
  ADD_CONSTRUCTION_TYPE_SUCCESS,
  ADD_CONSTRUCTION_TYPE_ERROR,
  EDIT_CONSTRUCTION_TYPE,
  EDIT_CONSTRUCTION_TYPE_SUCCESS,
  EDIT_CONSTRUCTION_TYPE_ERROR,
  DELETE_CONSTRUCTION_TYPE,
  DELETE_CONSTRUCTION_TYPE_SUCCESS,
  DELETE_CONSTRUCTION_TYPE_ERROR,
} from './types';

export const state = {
  constructionTypes: [],
  constructionTypesStatus: '',
  constructionTypesError: null,
  addConstructionTypeStatus: '',
  addConstructionTypeError: null,
  editConstructionTypeStatus: '',
  editConstructionTypeError: null,
  deleteConstructionTypeStatus: '',
  deleteConstructionTypeError: null,
};

export const getters = {
  constructionTypes: (state) => state.constructionTypes,
  constructionTypesStatus: (state) => state.constructionTypesStatus,
  constructionTypesError: (state) => state.constructionTypesError,
  addConstructionTypeStatus: (state) => state.addConstructionTypeStatus,
  addConstructionTypeError: (state) => state.addConstructionTypeError,
  editConstructionTypeStatus: (state) => state.editConstructionTypeStatus,
  editConstructionTypeError: (state) => state.editConstructionTypeError,
  deleteConstructionTypeStatus: (state) => state.deleteConstructionTypeStatus,
  deleteConstructionTypeError: (state) => state.deleteConstructionTypeError,
};

export const mutations = {
  [GET_CONSTRUCTION_TYPES](state) {
    state.constructionTypesStatus = 'loading';
    state.constructionTypesError = null;
  },
  [GET_CONSTRUCTION_TYPES_SUCCESS](state, constructionTypes) {
    state.constructionTypes = constructionTypes;
    state.constructionTypesStatus = 'success';
  },
  [GET_CONSTRUCTION_TYPES_ERROR](state, error) {
    state.constructionTypesStatus = 'error';
    state.constructionTypesError = error;
  },
  [ADD_CONSTRUCTION_TYPE](state) {
    state.addConstructionTypeStatus = 'loading';
    state.addConstructionTypeError = null;
  },
  [ADD_CONSTRUCTION_TYPE_SUCCESS](state) {
    state.addConstructionTypeStatus = 'success';
  },
  [ADD_CONSTRUCTION_TYPE_ERROR](state, error) {
    state.addConstructionTypeStatus = 'error';
    state.addConstructionTypeError = error;
  },
  [EDIT_CONSTRUCTION_TYPE](state) {
    state.editConstructionTypeStatus = 'loading';
    state.editConstructionTypeError = null;
  },
  [EDIT_CONSTRUCTION_TYPE_SUCCESS](state) {
    state.editConstructionTypeStatus = 'success';
  },
  [EDIT_CONSTRUCTION_TYPE_ERROR](state, error) {
    state.editConstructionTypeStatus = 'error';
    state.editConstructionTypeError = error;
  },
  [DELETE_CONSTRUCTION_TYPE](state) {
    state.deleteConstructionTypeStatus = 'loading';
    state.deleteConstructionTypeError = null;
  },
  [DELETE_CONSTRUCTION_TYPE_SUCCESS](state) {
    state.deleteConstructionTypeStatus = 'success';
  },
  [DELETE_CONSTRUCTION_TYPE_ERROR](state, error) {
    state.deleteConstructionTypeStatus = 'error';
    state.deleteConstructionTypeError = error;
  },
};
